var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { library } from "@fortawesome/fontawesome-svg-core";
import { faCheckCircle, faExclamationCircle, faSave } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { BAlert, BButton } from "bootstrap-vue";
import { computed, ref, watch } from "vue";
import { GalaxyApi } from "@/api";
import {} from "@/api/notifications";
import { useConfig } from "@/composables/config";
import { Toast } from "@/composables/toast";
import { browserSupportsPushNotifications, pushNotificationsEnabled, togglePushNotifications, } from "@/composables/utils/pushNotifications";
import { errorMessageAsString } from "@/utils/simple-error";
import NotificationsCategorySettings from "./NotificationsCategorySettings.vue";
import AsyncButton from "@/components/Common/AsyncButton.vue";
import Heading from "@/components/Common/Heading.vue";
import LoadingSpan from "@/components/LoadingSpan.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'NotificationsPreferences',
    props: {
        embedded: { type: Boolean, default: true },
        headerSize: { default: "h-lg" }
    },
    setup(__props) {
        const props = __props;
        library.add(faCheckCircle, faExclamationCircle, faSave);
        const { config } = useConfig(true);
        const loading = ref(false);
        const errorMessage = ref(null);
        const pushNotificationsGranted = ref(pushNotificationsEnabled());
        const notificationsPreferences = ref({});
        const supportedChannels = ref([]);
        const categories = computed(() => Object.keys(notificationsPreferences.value));
        const showPreferences = computed(() => {
            return !loading.value && config.value.enable_notification_system && notificationsPreferences.value;
        });
        function getNotificationsPreferences() {
            var _a, _b;
            return __awaiter(this, void 0, void 0, function* () {
                loading.value = true;
                try {
                    const { response, data, error } = yield GalaxyApi().GET("/api/notifications/preferences");
                    if (error) {
                        errorMessage.value = errorMessageAsString(error);
                        return;
                    }
                    const serverSupportedChannels = (_b = (_a = response.headers.get("supported-channels")) === null || _a === void 0 ? void 0 : _a.split(",")) !== null && _b !== void 0 ? _b : [];
                    supportedChannels.value = serverSupportedChannels;
                    notificationsPreferences.value = data.preferences;
                }
                finally {
                    loading.value = false;
                }
            });
        }
        function updateNotificationsPreferences() {
            return __awaiter(this, void 0, void 0, function* () {
                const { data, error } = yield GalaxyApi().PUT("/api/notifications/preferences", {
                    body: {
                        preferences: notificationsPreferences.value,
                    },
                });
                if (error) {
                    errorMessage.value = errorMessageAsString(error);
                    return;
                }
                notificationsPreferences.value = data.preferences;
                Toast.success("Notifications preferences updated");
            });
        }
        function onTogglePushNotifications() {
            return __awaiter(this, void 0, void 0, function* () {
                pushNotificationsGranted.value = yield togglePushNotifications();
            });
        }
        watch(() => config.value.enable_notification_system, () => {
            if (config.value.enable_notification_system) {
                getNotificationsPreferences();
            }
        }, { immediate: true });
        function onCategoryEnabledChange(category, value) {
            notificationsPreferences.value[category].enabled = value;
        }
        function onChannelChange(category, channel, value) {
            notificationsPreferences.value[category].channels[channel] = value;
        }
        return { __sfc: true, props, config, loading, errorMessage, pushNotificationsGranted, notificationsPreferences, supportedChannels, categories, showPreferences, getNotificationsPreferences, updateNotificationsPreferences, onTogglePushNotifications, onCategoryEnabledChange, onChannelChange, faCheckCircle, faExclamationCircle, faSave, FontAwesomeIcon, BAlert, BButton, browserSupportsPushNotifications, NotificationsCategorySettings, AsyncButton, Heading, LoadingSpan };
    }
});
